import { Box } from "@mui/material";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { FilterDetailsContainer, styles } from "../../pages/Tracks/styles";
import { FilterAndSortDetailsProps, versionState } from "./types";

export const FilterAndSortDetails: React.FC<FilterAndSortDetailsProps> = ({
  filterAndSortParams,
  value,
  setFilterAndSortParams,
  setPage,
  setTracks,
  queryValue,
  setQueryValue,
}) => {
  return (
    <>
      {queryValue && (
        <FilterDetailsContainer>
          {queryValue !== "" && (
            <Box sx={styles.filterAndSortValueContainer}>
              {(() => {
                try {
                  return decodeURIComponent(queryValue).replace(/\\/g, "");
                } catch (error) {
                  console.error("Invalid URI component:", queryValue, error);
                  return queryValue;
                }
              })()}
              <IconButton
                onClick={() => {
                  setPage(0);
                  setTracks([]);
                  setQueryValue("");
                }}
              >
                <CloseIcon sx={styles.closeIcon} />
              </IconButton>
            </Box>
          )}
        </FilterDetailsContainer>
      )}
      <FilterDetailsContainer>
        {filterAndSortParams?.genreList[0] && (
          <Box sx={styles.filterAndSortValueContainer}>
            {filterAndSortParams.genreList[0]}
            <IconButton
              onClick={async () => {
                setPage(0);
                setTracks([]);
                setFilterAndSortParams((prev) => {
                  return {
                    ...prev,
                    genreList: [],
                  };
                });
              }}
            >
              <CloseIcon sx={styles.closeIcon} />
            </IconButton>
          </Box>
        )}
        {filterAndSortParams.artistList[0] && (
          <Box sx={styles.filterAndSortValueContainer}>
            {filterAndSortParams.artistList[0]}
            <IconButton
              onClick={() => {
                setPage(0);
                setTracks([]);
                setFilterAndSortParams((prev) => {
                  return {
                    ...prev,
                    artistList: [],
                  };
                });
              }}
            >
              <CloseIcon sx={styles.closeIcon} />
            </IconButton>
          </Box>
        )}
        {filterAndSortParams.collaboratorsList?.map((c, i) => {
          return (
            <Box key={i} sx={styles.filterAndSortValueContainer}>
              {c}
              <IconButton
                onClick={() => {
                  setPage(0);
                  setTracks([]);
                  setFilterAndSortParams((prev) => {
                    return {
                      ...prev,
                      collaboratorsList:
                        prev && prev.collaboratorsList
                          ? prev.collaboratorsList.filter((str) => str !== c)
                          : [],
                    };
                  });
                }}
              >
                <CloseIcon sx={styles.closeIcon} />
              </IconButton>
            </Box>
          );
        })}
        {filterAndSortParams.TrackPrivacy !== "All" && (
          <Box sx={styles.filterAndSortValueContainer}>
            {filterAndSortParams.TrackPrivacy}
            <IconButton
              onClick={() => {
                setPage(0);
                setTracks([]);
                setFilterAndSortParams((prev) => {
                  return {
                    ...prev,
                    TrackPrivacy: "All",
                  };
                });
              }}
            >
              <CloseIcon sx={styles.closeIcon} />
            </IconButton>
          </Box>
        )}
        {filterAndSortParams.status !== "" && (
          <Box
            sx={{
              ...styles.filterAndSortValueContainer,
              display: value === 2 ? "none" : "block",
            }}
          >
            {versionState[+filterAndSortParams.status]}
            <IconButton
              onClick={() => {
                setPage(0);
                setTracks([]);
                setFilterAndSortParams((prev) => {
                  return {
                    ...prev,
                    status: "",
                  };
                });
              }}
            >
              <CloseIcon sx={styles.closeIcon} />
            </IconButton>
          </Box>
        )}
        {filterAndSortParams.sortBy !== "Custom Order" &&
          filterAndSortParams.sortBy !== "Last modified" && (
            <Box sx={styles.filterAndSortValueContainer}>
              {filterAndSortParams.sortBy}
              <IconButton
                onClick={() => {
                  setPage(0);
                  setTracks([]);
                  setFilterAndSortParams((prev) => {
                    return {
                      ...prev,
                      sortBy: "Last modified",
                      isAscending: false,
                    };
                  });
                }}
              >
                <CloseIcon sx={styles.closeIcon} />
              </IconButton>
            </Box>
          )}
      </FilterDetailsContainer>
    </>
  );
};
